import { render, staticRenderFns } from "./AppointmentType.vue?vue&type=template&id=59d6bc86&scoped=true&"
import script from "./AppointmentType.vue?vue&type=script&lang=js&"
export * from "./AppointmentType.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentType.vue?vue&type=style&index=0&id=59d6bc86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d6bc86",
  null
  
)

export default component.exports